import React, { useEffect, useState } from "react";
import InventoryFooter from "./InventoryComponent/InventoryFooter";
import InventoryTable from "./InventoryComponent/InventoryTable";
import InventorySideBar from "./InventoryComponent/InventorySideBar";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { FaBars, FaTimes } from 'react-icons/fa';
import "../css/custom.css";
import "../css/style.css";
import "../css/skin-default.css";
import { useLocation } from "react-router-dom";
import { useInventoryProductContext } from "../../Context/Cache/InventoryProductContext";
import { useAuthenticationContext } from "../../Context/Authentication";
import { AtuInventoryProvider } from "../../Context/Cache/ATU/AtuInventoryContext";
import { LoadingScreen } from "../LoadingScreen";
const MainInventory = () => {
  const {screenSize} = useAuthenticationContext()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const {
        categoryData,
    subCategoryData,
    brandData,
    itemCategoryCodeData,
    colorData,
    packagingData,
    selectedCategories,
    selectedSubCategories,
    selectedBrands,
    selectedItemCategoryCodes,
    setSelectedCategories,
    setSelectedSubCategories,
    setSelectedBrands,
    setSelectedItemCategoryCodes,
    selectedColors,
    setSelectedColors,
    selectedPackaging,
    setSelectedPackaging,
    handleCheckboxChange,
    fetchFilteredProducts,
    fetchDataFromCache,
    products,
    inventoryFilteredProducts,
    applyFilters,
    isRangeChanged,
    setIsRangeChanged,
    clearAllFilters,
    isLoading,
    showApplyFilterOptions,setShowApplyFilterOptions,
    updateApplyFilterOptions,setUpdateApplyFilterOptions,
    combinedSelectedItems,setCombinedSelectedItems,
    isExpanded, setIsExpanded,
        toggleWidth,skuData,
    setSkuData,
    selectedSku,
    setSelectedSku,
    isRealLoading
  } = useInventoryProductContext();
 
  const [clearIndividualFilter, setClearIndividualFilter] = useState(false)
 
  const getLabelByValue = (value, data) => {
    const item = data.find((item) => item.value === value);
    return item ? item.label : value;
  };
 

// Amit 02-08-2024
useEffect(()=>{
  if(updateApplyFilterOptions==true){
        setCombinedSelectedItems( [
          ...selectedCategories.map((item) => ({
            label: getLabelByValue(item, categoryData),
            value: item,
            type: "category",
            setSelected: setSelectedCategories,
          })),
          ...selectedSubCategories.map((item) => ({
            label: getLabelByValue(item, subCategoryData),
            value: item,
            type: "subcategory",
            setSelected: setSelectedSubCategories,
          })),
          ...selectedBrands.map((item) => ({
            label: getLabelByValue(item, brandData),
            value: item,
            type: "brand",
            setSelected: setSelectedBrands,
          })),
          ...selectedItemCategoryCodes.map((item) => ({
            label: getLabelByValue(item, itemCategoryCodeData),
            value: item,
            type: "itemCategoryCode",
            setSelected: setSelectedItemCategoryCodes,
          })),
          ...selectedColors.map((item) => ({
            label: getLabelByValue(item, colorData),
            value: item,
            type: "color",
            setSelected: setSelectedColors,
          })),
          ...selectedPackaging.map((item) => ({
            label: getLabelByValue(item, packagingData),
            value: item,
            type: "packaging",
            setSelected: setSelectedPackaging,
          })),
          ...selectedSku.map((item) => ({
            label: getLabelByValue(item, skuData),
            value: item,
            type: "sku",
            setSelected: setSelectedSku,
          })),
        ]);
        setUpdateApplyFilterOptions(false);
  }

},[updateApplyFilterOptions]);
 
  const handleRemoveItem = async (item) => {
    item.setSelected((prevSelectedItems) =>
      prevSelectedItems.filter((i) => i !== item.value)
    );
    setClearIndividualFilter(true)
  };
 
  useEffect(() => {
    if (clearIndividualFilter) {
      fetchFilteredProducts()
      setClearIndividualFilter(false)
    }
  }, [clearIndividualFilter])
 
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  }
  
  return (
    <div className="p-2 bg-gray-100 flex flex-col justify-start nycfix-filter-container" style={{maxWidth: `${screenSize.width}px` }}>
      {isLoading && <LoadingScreen />}
      {isRealLoading && <LoadingScreen message="Loading real-time inventory. Please wait..." color="#e74c3c" />}
      {(combinedSelectedItems.length > 0)&&(showApplyFilterOptions == true)&&(
        <div className="flex" style={{maxWidth: `${screenSize.width - 50}px`}}>
          <div className="col-lg-3">
            <BreadCrumb />
          </div>
          <div className="col-lg-9 breadcrumb-wrap nycfix-breadcrumb-wrap">
            <nav aria-label="breadcrumb">
              <div className="tags nycfix-tags">
                Showing
                {combinedSelectedItems.map((item, index) => (
                  <span key={index} className="tag">
                    {item.label}{" "}
                    <span
                      className="close-btn"
                      onClick={() => handleRemoveItem(item)}
                    >
                      &times;
                    </span>
                  </span>
                ))}
                <span className="clear-all" onClick={clearAllFilters}>
                  Clear All
                </span>
              </div>
            </nav>
          </div>
        </div>
      )}
      <div className="">
      <div className="row">
          <AtuInventoryProvider>
            {screenSize.width < 992 && (
              <div className="nycfix-sidebar-icon" onClick={toggleSidebar}>
                {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </div>
            )}
            <div className="gap-3 nycfix-row1">
            <div className={`nycfix-sidebar-wrapper ${isSidebarOpen ? 'open' : ''}`}>
              <InventorySideBar />
            </div>
            <div className="">
            <InventoryTable />
            </div>
            </div>
            <InventoryFooter />
          </AtuInventoryProvider>
        </div>
      </div>
    </div>
  );
};
 
export default MainInventory;